import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'germanCurrency'
})
export class GermanCurrencyPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value === 0) {
      return '0,00 €';
    }
    return value
      ? value.toLocaleString('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + ' €'
      : '';
  }
}
